export default __webpack_public_path__ + "fe70f5de868f592629c2b32f4c49e42a.svg";